import { ConversationStatusResponse, Participation, StreamingSessionResponse } from '@/types/participationV1';
import { api } from './client';
import { hubApi } from './hubClient';

export const participationV1Api = {
  get: async (participationId: string): Promise<Participation> => {
    const { data } = await api.get(`/api/v1/participations/${participationId}`);
    return data;
  },

  // Starts (or resumes) the streaming session of a situation
  startSituation: async (participationId: string, situationId: string, salt: string): Promise<StreamingSessionResponse> => {
    const { data } = await hubApi.put(`/api/v1/participations/${participationId}`, null, { params: { situation_id: situationId, salt: salt } });
    return data;
  },

  // Long-polls the state of a running conversation: answers "no_response_yet" after ~30s while it is running.
  // The 400 "conversation_error" is a business response, returned instead of thrown.
  getConversationStatus: async (participationId: string, situationId: string, salt: string): Promise<ConversationStatusResponse> => {
    try {
      const { data } = await hubApi.get(`/api/v1/participations/${participationId}`, { params: { situation_id: situationId, salt: salt } });
      return data;
    } catch (error) {
      if (error.response?.data?.type === 'conversation_error') return error.response.data;
      throw error;
    }
  },

  // Ends the participation (204 No Content)
  complete: async (participationId: string): Promise<void> => {
    await api.post(`/api/v1/participations/${participationId}/complete`);
  },
}
